import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, unref as _unref, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createVNode as _createVNode, withCtx as _withCtx, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "sqg-createFolder" }
const _hoisted_2 = { class: "sqg-createFolder__content" }
const _hoisted_3 = {
  key: 2,
  class: "sqg-createFolder__responsableChoice"
}
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" Sélectionner le responsable sur lequel vous souhaitez rattacher le collaborateur ")
const _hoisted_5 = ["onClick"]
const _hoisted_6 = ["onSubmit"]
const _hoisted_7 = {
  key: 0,
  class: "sqg-createFolder__info"
}
const _hoisted_8 = /*#__PURE__*/_createTextVNode("Créer le dossier")

import {onMounted, ref} from "vue";
import {useFoldersStore} from "@/stores/folders";
import {useUserStore} from "@/stores/user";
import Modale from '@/modales/Modale.vue';
import Input from '@/components/Input.vue';
import Button from '@/components/Button.vue';
import Loader from '@/components/Loader.vue';
import {storeToRefs} from "pinia";
import {randomColor} from '@/functions/utils';


export default /*#__PURE__*/_defineComponent({
  props: {
  isOpen: { type: Boolean, default: 'false' },
},
  emits: ['createFolder'],
  setup(__props, { emit }) {

const props = __props





//STORE Folders
const foldersStore = useFoldersStore();
//STORE Users
const usersStore = useUserStore();
const { user } = storeToRefs(usersStore);

//DATA
const folderName = ref('');
const loader = ref(false);

const responsableLoader = ref(false);
const responsables = ref<Array<any>>([]);
const step = ref(2);
const isAdmin = ref(false);

const createFolder = () => {
  loader.value = true;
  foldersStore.createFolder(folderName.value, responsableId.value).then(() => {
    loader.value = false;
    folderName.value = '';
    emit('createFolder');
  });
}

const responsableId = ref(undefined);
const selectResponsable = (responsable) => {
  responsableId.value = responsable;
  step.value = 2;
};

const getResponsables = () => {
  responsableLoader.value = true;
  usersStore.getResponsables().then((response) => {
    responsableLoader.value = false;
    responsables.value = response;
  });
};

onMounted(() => {
  if (user.value.role === 'admin' || user.value.role === 'superAdmin') isAdmin.value = true;
  if (isAdmin.value) {
    step.value = 1;
    getResponsables();
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (props.isOpen)
      ? (_openBlock(), _createBlock(Modale, {
          key: 0,
          width: "30",
          height: "50",
          title: "Créer un dossier",
          onClose: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('close')))
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              (loader.value)
                ? (_openBlock(), _createBlock(Loader, {
                    key: 0,
                    msg: "Création du dossier ..."
                  }))
                : (isAdmin.value && responsableLoader.value)
                  ? (_openBlock(), _createBlock(Loader, {
                      key: 1,
                      msg: "Chargement des responsables"
                    }))
                  : (step.value === 1)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                        _hoisted_4,
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(responsables.value, (responsable) => {
                          return (_openBlock(), _createElementBlock("div", {
                            class: "sqg-createFolder__responsable clickable",
                            key: responsable.id,
                            onClick: ($event: any) => (selectResponsable(responsable.id))
                          }, [
                            _createElementVNode("div", {
                              class: "sqg-createFolder__nameIcon",
                              style: _normalizeStyle(`background-color: ${_unref(randomColor)(responsable.id)}`)
                            }, _toDisplayString(responsable.firstname[0]) + _toDisplayString(responsable.lastname[0]), 5),
                            _createTextVNode(" " + _toDisplayString(responsable.firstname) + " " + _toDisplayString(responsable.lastname), 1)
                          ], 8, _hoisted_5))
                        }), 128))
                      ]))
                    : _createCommentVNode("", true),
              (step.value === 2 && !loader.value)
                ? (_openBlock(), _createElementBlock("form", {
                    key: 3,
                    class: "sqg-createFolder__form",
                    onSubmit: _withModifiers(createFolder, ["prevent"])
                  }, [
                    (_unref(user).role === 'gestionnaireDeDossier')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_7, "Le dossier ne sera pas accessible tant qu'il n'aura pas été validé par un responsable de compte."))
                      : _createCommentVNode("", true),
                    _createVNode(Input, {
                      type: "text",
                      placeholder: "Nom du dossier",
                      modelValue: folderName.value,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((folderName).value = $event))
                    }, null, 8, ["modelValue"]),
                    _createVNode(Button, { type: "submit" }, {
                      default: _withCtx(() => [
                        _hoisted_8
                      ]),
                      _: 1
                    })
                  ], 40, _hoisted_6))
                : _createCommentVNode("", true)
            ])
          ]),
          _: 1
        }))
      : _createCommentVNode("", true)
  ]))
}
}

})